import PropTypes from "prop-types";
import React, { Component } from "react";
import styled from "styled-components";

const ModalWrapper = styled.div`
  background: rgba(0, 0, 0, ${props => (props.blur ? "0.15" : "0.4")});
  color: ${props => props.theme.colors.darkBlue};
  position: fixed;
  bottom: 0;
  right: 0;
  left: 0;
  top: 0;
  pointer-events: auto;
  z-index: ${props => props.theme.zIndexes.modal};
  display: grid;
  align-content: center;
  justify-content: center;

  ${""} > div {
    text-align: center;
    ${props =>
      props.noBackground
        ? ""
        : `
        background: white;
        border-radius: 5px;
        box-shadow: 0 1px 4px 0 ${props.theme.colors.shadowGrey};
        padding: 30px 20px;`}
    margin: 20px;
    pointer-events: all;

    > * {
      font-family: ${props => props.theme.typography.fontStack};
      font-size: ${props => props.theme.typography.defaultFontSize};
      line-height: ${props => props.theme.typography.defaultLineHeight};
    }

    > p {
      display: flex;
      color: #888;
      font-size: 16px;
      line-height: 20px;
      margin: 0 auto 20px;
      max-width: 400px;
    }

    h2 {
      display: block;
      font-size: 22px;
      font-weight: 600;
      line-height: 28px;
      margin-bottom: 20px;
    }

    h3 {
      display: block;
      font-weight: 600;
      margin-bottom: 10px;
      font-size: 20px;
      line-height: 28px;
    }

    strong {
      font-weight: bold;
    }

    > button.close {
      -webkit-appearance: none;
      outline: none;
      appearance: none;
      background: transparent;
      border: none;
      position: absolute;
      right: 5px;
      top: 5px;
      text-indent: -9999em;

      &:after {
        -webkit-appearance: none;
        appearance: none;
        content: "×";
        color: ${props => props.theme.colors.midGrey};
        cursor: pointer;
        display: block;
        font-size: 30px;
        line-height: 25px;
        position: absolute;
        right: 0;
        top: 0;
        height: 30px;
        text-align: center;
        text-indent: 0;
        width: 30px;
      }
    }
  }
`;

// Can't be stateless functional component because of react-portal
class Modal extends Component {
  componentDidMount() {
    if (this.props.blur) {
      this.changeBackgroundBlur(element => element.classList.add("blur"));
    }
    window.document.body.style.overflow = "hidden";
  }

  componentWillUnmount() {
    if (this.props.blur) {
      this.changeBackgroundBlur(element => element.classList.remove("blur"));
    }
    window.document.body.style.overflow = "auto";
  }

  changeBackgroundBlur = change => {
    if (this.props.backgroundIds) {
      this.props.backgroundIds.forEach(backgroundId => {
        const element = window.document.getElementById(backgroundId);
        if (element) {
          change(element);
        }
      });
    }
  };

  render() {
    const {
      noBackground,
      children,
      closePortal,
      small,
      closeButton,
      blur
    } = this.props;
    return (
      <ModalWrapper small={small} blur={blur} noBackground={noBackground}>
        <div>
          {children.length
            ? children.map(child => React.cloneElement(child))
            : React.cloneElement(children)}
          {closeButton && (
            <button className="close" onClick={closePortal}>
              Close
            </button>
          )}
        </div>
      </ModalWrapper>
    );
  }
}

Modal.propTypes = {
  backgroundIds: PropTypes.arrayOf(PropTypes.string),
  closeButton: PropTypes.bool,
  closePortal: PropTypes.func,
  children: PropTypes.node.isRequired,
  noBackground: PropTypes.bool,
  small: PropTypes.bool,
  blur: PropTypes.bool
};

Modal.defaultProps = {
  backgroundIds: [],
  closeButton: false,
  closePortal: () => {},
  noBackground: false,
  small: false,
  blur: true
};

export default Modal;
